<template lang="slm">
section.Folk style="margin-bottom: 88px;"
  .container
    .columns.is-multiline
      .column.is-12
        .SearchBox-content
          h4.title.SearchBox-heading.has-text-centered {{title}}
      .column.is-6-widescreen.is-offset-3-widescreen.is-10-tablet.is-offset-1-tablet.is-8-desktop.is-offset-2-desktop
        .PeopleSearchResult.Typeahead :style="{position: 'relative'}"
          input.Typeahead-input.typeahead type="text" autocomplete="off" v-model="term" placeholder="Fyll inn navn du leter etter"
          pulse-loader color="#aaa" class="Spinner" size="10px" v-if="searching"
    .columns.is-multiline v-if="foundPeople.length > 0"
      .column.is-6.is-4-widescreen v-for="person in foundPeople"
        person-card :person="person" :key="person._id"
    .columns v-else-if="searched"
      .column :style="{textAlign: 'center'}"
        h3
          |Fant ingen ved det navnet


</template>

<script>
import PersonCard from '@/components/PersonCard'
import sanityQuery from '@/sanityQuery'
import PulseLoader from 'vue-spinner/src/PulseLoader.vue'

export default {
  props: ['title'],
  components: {
    'person-card': PersonCard,
    PulseLoader
  },
  data () {
    return {
      term: '',
      foundPeople: [],
      inputFocus: true,
      delayedSearch: null,
      searched: false,
      searching: true
    }
  },
  watch: {
    term: function (term) {
      this.searched = false
      if (term !== '') {
        clearTimeout(this.delayedSearch)
        this.delayedSearch = setTimeout(this.sanitySearch, 500)
      } else {
        this.foundPeople = []
      }
    }
  },
  methods: {
    sanitySearch () {
      if (this.term.split('').length > 0) {
        this.searching = true
        var query = `*[_type == "person" && name match [${this.term.toLowerCase().split(/\s+/).map(s => `"${s}*"`)}]] | order(name) [0...5000]{
          _id, name, email, phone, twitter, facebook, instagram, 
          profile_image{..., asset->}}`
        sanityQuery(query)
          .then(result => {
            this.searching = false
            this.searched = true
            if (result.length > 0) {
              this.foundPeople = result
            }
          })
      } else {
        this.foundPeople = []
      }
    }
  }
}
</script>

<style lang="css">
.fade-enter-active, .fade-leave-active {
  transition: all .5s;
}

.fade-enter, .fade-leave-to /* .fade-leave-active in <2.1.8 */ {
  opacity: 0;
  transform: translateY(30px);
}

.IssueSearchResult {
  position: relative;
}
.tt-menu {
  position: absolute;
  top: 100%;
  left: 0px;
  z-index: 100;
}

.Spinner {
  position: absolute;
  right: 20px;
  bottom: 0;
  top: 23px;
}
</style>



// WEBPACK FOOTER //
// src/components/PersonSearch.vue